import Image from 'next/image';
import { ArrowDown, BusinessIcon, UserIcon } from 'assets/img';

const LoggedInAvatar = ({ onClick, currentUser, isAdmin }) => (
  <button 
    onClick={onClick} 
    className="flex items-center justify-center h-12 min-w-[98px] px-4 py-2 gap-2 rounded-[24px] bg-white"
  >
    <div className="flex items-center gap-2">
      <Image src={isAdmin ? BusinessIcon : UserIcon} alt="business-icon" className="text-[#575BE8]" />

      <span className="text-[#575BE8] font-inter font-medium text-base leading-[24px] capitalize">
        {currentUser?.attributes?.first_name} {currentUser?.attributes?.last_name}
      </span>
    </div>

    <Image src={ArrowDown} alt="arrow-down" className="text-[#575BE8]" />
  </button>
);

export default LoggedInAvatar;